import * as React from 'react';
import PropTypes from 'prop-types';
import { StaticQuery, graphql } from 'gatsby';
import { LocomotiveScrollProvider } from 'react-locomotive-scroll';
import { Header, Footer, Instagram } from './index';
import Preloader from './Preloader/Preloader';

import { footerData } from '../../db/footerData';

const Layout = ({ children }) => {
  const containerRef = React.useRef(null);

  return (
    <div className="app-container">
      <LocomotiveScrollProvider
        options={{
          smooth: true,
          tablet: { smooth: true },
          smartphone: { smooth: true },
          getDirection: true,
          touchMultiplier: 2.5,
          lerp: 0.5,
          firefoxMultiplier: 200,
          inertia: 0.95,
        }}
        watch={[]}
        containerRef={containerRef}
      >
        <div
          id="container"
          className="scroll-container"
          data-scroll-container
          ref={containerRef}
        >
          <Preloader />
          <StaticQuery
            query={graphql`
              query HeadingQuery {
                strapiInstaFeed {
                  title_ua
                  title_ru
                  instagram {
                    title_ua
                    title_ru
                    link
                    insta_photo {
                      image {
                        localFile {
                          childImageSharp {
                            gatsbyImageData(
                              width: 1400
                              placeholder: BLURRED
                              formats: [AUTO, WEBP, AVIF]
                            )
                          }
                        }
                      }
                    }
                  }
                }
                strapiContacts {
                  Socials {
                    title
                    link
                  }
                  Messengers {
                    title
                    link
                  }
                  phone
                  mail
                }
                strapiHome {
                  home_services {
                    Services {
                      title_ua
                      title_ru
                      description_ua
                      description_ru
                      link
                    }
                  }
                }
              }
            `}
            render={(data) => (
              <>
                <Header dataSubNav={data.strapiHome.home_services} />
                <main>{children}</main>
                <Instagram insta={data.strapiInstaFeed} />
                <Footer
                  dataContacts={data.strapiContacts}
                  dataFooter={footerData}
                />
              </>
            )}
          />
        </div>
      </LocomotiveScrollProvider>
    </div>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
